import { tv, type VariantProps } from "tailwind-variants";

export const newsCardVariant = tv({
  slots: {
    base: ["flex gap-4 items-start"],
    figureWrapper: [],
    figure: [
      "rounded-3xl",
      "overflow-hidden",
      "focus-within:outline focus-within:outline-2",
    ],
    link: ["block border-b border-gray-600 last:border-none"],
    textWrapper: [],
    preTitle: ["hidden", "text-blue-400"],
    title: ["hover:text-blue-400"],
  },
  variants: {
    appearance: {
      horizontal: {
        base: ["flex-row-reverse gap-6 items-center", "py-6"],
        figureWrapper: ["basis-full", "max-w-[150px]"],
        textWrapper: ["flex flex-col gap-2 basis-full"],
        preTitle: ["flex"],
        title: ["text-gray-40"],
      },
      vertical: {
        base: ["flex-col"],
        title: ["text-gray-40 font-semibold"],
        figureWrapper: ["w-[200px] md:w-full"],
      },
    },
    highlight: {
      true: {
        base: ["mt-[-24px]"],
        preTitle: ["flex", "!text-display-16", "mb-4"],
        title: ["!text-display-24"],
        figureWrapper: ["w-full"],
      },
      false: {
        title: [
          "!text-display-16 leading-snug",
          "text-ellipsis overflow-hidden",
        ],
      },
    },
  },
});

export type NewsCardVariantProps = VariantProps<typeof newsCardVariant>;
